'use client';

import React from 'react';
import { useRouter } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const router = useRouter();

  return (
    <html>
      <body className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
        <div className="text-center max-w-md">
          <div className="flex justify-center mb-6">
            <h1 className="text-9xl font-bold text-primary opacity-20">500</h1>
          </div>
          <h2 className="text-2xl font-medium text-onBackground mb-2">Something went wrong</h2>
          <p className="text-onBackground/70 mb-8">
            An unexpected error occurred. Our team has been notified.
            {error?.digest && (
              <span className="block mt-2 text-xs text-onBackground/40 font-mono">
                Error ID: {error.digest}
              </span>
            )}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={reset}
              className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-lg font-medium hover:bg-primary/90 transition-colors duration-200"
            >
              <Icon name="ArrowPathIcon" size={16} />
              Try Again
            </button>
            <button
              onClick={() => router?.push('/')}
              className="inline-flex items-center justify-center gap-2 border border-border bg-background text-foreground px-6 py-3 rounded-lg font-medium hover:bg-accent hover:text-accent-foreground transition-colors duration-200"
            >
              <Icon name="HomeIcon" size={16} />
              Back to Home
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
